import React from 'react';
import PropTypes from 'prop-types';

function ChevronDownIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='m6 9 6 6 6-6' />
    </svg>
  );
}

ChevronDownIcon.propTypes = {
  className: PropTypes.string,
};

export default ChevronDownIcon;
